import type { QueryClientConfig } from '@tanstack/vue-query';
import type { Strapi5Error } from '@nuxtjs/strapi';

const config: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: retryFn,
      placeholderData: (previousValue: unknown) => previousValue,
    },
    mutations: {
      retry: retryFn,
    },
  },
};

function retryFn(failureCount: number, e: unknown) {
  const error = (e as unknown as Strapi5Error)?.error;

  if (
    error?.status &&
    [400, 401, 403, 404, 405, 413, 422].includes(error.status)
  ) {
    return false;
  } else {
    return failureCount < 2;
  }
}

export default config;
